import SizeGuideButton from "../sizeGuideButton/SizeGuideButton";
import FitAssistantLink from "../fitAssistant/FitAssistantLink";
import { useSizing } from "../../context/sizing/SizingContext";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import useFitAssistExperiment from "../fitAssistant/useFitAssistExperiment";
import { useOptionalMySizeProfile } from "../../context/mySizeProfile/MySizeProfileContext";

export default function SizeAndFitContainer() {
  const {
    sizeGuideUrl,
    fitAssistantLinkText,
    handleFitAssistantLinkClick,
    showFitIcon,
  } = useSizing();
  const { getTranslation } = useRuntimeConstants();
  const {
    isEligible: isMySizeProfileEligible,
    isAuthenticated: isMySizeProfileAuthenticated,
  } = useOptionalMySizeProfile();
  const shouldSuppressForMySizeProfile =
    isMySizeProfileEligible && isMySizeProfileAuthenticated;
  const { isSuppressed } = useFitAssistExperiment({
    fitAssistEligible: !!fitAssistantLinkText,
    shouldSuppressForMySizeProfile,
  });

  const showSizeGuide =
    !!sizeGuideUrl &&
    (!fitAssistantLinkText || isSuppressed) &&
    !shouldSuppressForMySizeProfile;
  const showFitAssistant =
    !!fitAssistantLinkText && !isSuppressed && !shouldSuppressForMySizeProfile;

  return (
    <>
      {showSizeGuide && (
        <SizeGuideButton
          sizeGuideUrl={sizeGuideUrl}
          text={getTranslation("pdp_size_guide_link")}
          entryPoint="sizeguide-above-variant-selector"
        />
      )}
      {showFitAssistant && (
        <FitAssistantLink
          fitAssistantLinkText={fitAssistantLinkText}
          handleFitAssistantLinkClick={handleFitAssistantLinkClick}
          showFitIcon={showFitIcon}
        />
      )}
    </>
  );
}
